import { collections } from "@/mocks/chiagua";

export default function Collections() {
  return (
    <section id="collect" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-secondary-700">Deep Archive</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">深度合集 · 藏好瓜整理馆</h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              把散落在各处的信息串成可检索的档案，越吃越懂行。合集持续更新，值得反复回味的瓜都在这里。
            </p>
          </div>
          <a href="#join" className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700">
            进入合集档案馆 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((c, idx) => (
            <a
              key={c.title}
              href="#collect"
              className="group relative block overflow-hidden rounded-2xl border border-background-200 bg-background-50"
            >
              <div className="relative h-44 w-full overflow-hidden md:h-52">
                <img
                  src={c.img}
                  alt={c.title}
                  title={"吃瓜福利 " + c.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent"></div>
                <span className="absolute left-3 top-3 rounded-md bg-foreground-950/70 px-2.5 py-1 text-xs font-medium text-background-50">
                  合集 #{String(idx + 1).padStart(2, "0")}
                </span>
                <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-semibold text-primary-700">
                  <i className="ri-archive-line"></i> {c.count} 篇
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-700">{c.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
                <p className="mt-4 text-xs font-medium text-accent-700 group-hover:text-accent-800">进入查看 →</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}